<hr />
<ccp-inventorysource [group]="group" [formArray]="formArray" [isNew]="isNew" [advertiserInfo]="advertiserInfo">
</ccp-inventorysource>

<private-deals [group]="group" [formArray]="formArray" [isNew]="isNew" [advertiserInfo]="advertiserInfo">
</private-deals>

<pg-deal [group]="group" [formArray]="formArray" [isNew]="isNew" [advertiserInfo]="advertiserInfo">
</pg-deal>

<amobee-preferred-deals [group]="group" [formArray]="formArray" [isNew]="isNew" [advertiserInfo]="advertiserInfo">
</amobee-preferred-deals>

<advanced-budget-allocation [group]="group" [formArray]="formArray" [isNew]="isNew" [advertiserInfo]="advertiserInfo">
</advanced-budget-allocation>